import { Component } from '@angular/core';
import { AnalyticsService } from 'src/app/service/analytics/analytics.service';
import { PRODUCT_HEROES } from '../product-hero.data';
import { ProductShots, Shot } from '../product-shots';

// Promo landing page for the Color Picker JetBrains plugin, served at
// /plugins/jetbrains/color-picker. SEO is applied by the NavigationInterceptor
// from navigation.data.ts (client) and seo-route-meta.js (server). The copy
// describes only what the plugin actually does: eyedrop, conversions across
// every color space, WCAG and APCA checks, harmonies, tints, color vision
// simulations and recents. Reuses the Chrome picker page styles.
@Component( {
  selector: 'app-jetbrains-color-picker-page',
  templateUrl: './jetbrains-color-picker-page.component.html',
  styleUrls: [ '../chrome-color-picker-page/chrome-color-picker-page.component.scss', '../macos-tidy-desktop-page/macos-tidy-desktop-page.component.scss', '../product-page.scss' ],
} )
export class JetbrainsColorPickerPageComponent extends ProductShots {

  readonly marketplaceUrl = 'https://plugins.jetbrains.com/plugin/32652-color-picker';
  // The product on its stage at the top of the page (product-hero.data.ts), and the facts as
  // chips under the pitch.
  readonly hero = PRODUCT_HEROES[ 'jetbrains-color-picker' ];
  readonly facts = [ 'Free', 'IntelliJ IDEA, WebStorm, PyCharm', 'Every IntelliJ-Based IDE' ];


  readonly features = [
    {
      title: 'Eyedrop Anywhere',
      description: 'Sample any pixel on your screen with a magnifier. Your code, a design tool, an image, anything you can see.',
    },
    {
      title: 'Every Color Space',
      description: 'Hex, RGB, HSL, HSV, OKLCH, CIELAB, CMYK and more, plus copy-ready CSS rules, each one click to copy.',
    },
    {
      title: 'Accessibility Checks',
      description: 'WCAG 2 contrast ratio and APCA of the color as text on white, black and its complementary, with AA and AAA verdicts.',
    },
    {
      title: 'Harmony, Tints and Tones',
      description: 'Every classic scheme from the color wheel, with the color stepped toward white, black and gray.',
    },
    {
      title: 'Color Vision Deficiency',
      description: 'The color beside its simulation under protan, deutan, tritan and monochromacy vision, from mild to severe.',
    },
    {
      title: 'Recent Colors',
      description: 'Your last picks stay at the top of the tool window, so the shades you are working with are always one click away.',
    },
  ];

  // The first three things it does under the product's picture, the rest further down (the
  // Apps & Plugins layout, ../product-page.scss).
  readonly highlights = this.features.slice( 0, 3 );
  readonly more = this.features.slice( 3 );

  // Its store picture (2026-10-09, in All In One Themes' store style), under Screenshots; it
  // opens in the lightbox at full size.
  readonly shots: Shot[] = [
    {
      name: 'Grab Any Color',
      src: './assets/product-lines/tools/jetbrains-color-picker/screenshot-grab-any-color.webp',
      large: './assets/product-lines/tools/jetbrains-color-picker/screenshot-grab-any-color-large.webp',
      alt: 'Grab any color, right in your IDE: the Color Picker tool window with its hex field, recent colors and a picked blue in every color space',
    },
  ];

  constructor( private analyticsService: AnalyticsService ) {
    super();
  }

  onInstall(): void {
    this.analyticsService.logEvent( 'Plugin Install Clicked', { plugin: 'jetbrains-color-picker' } );
  }
}
